// localStorage is now an OFFLINE-READ CACHE ONLY — never the primary source of truth.
// Firestore is authoritative (see lib/sync.js). We still write to localStorage on every
// save so the app has something to show instantly on next boot / while offline, and so
// nothing is lost if a save happens while the network is down, but we never treat what's
// in localStorage as more current than what Firestore says once a snapshot arrives.
const CACHE_KEY = 'levelup_cache_v1';

export function readCache() {
  try {
    const raw = localStorage.getItem(CACHE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    console.error('readCache failed', e);
    return null;
  }
}

export function writeCache(state) {
  try {
    localStorage.setItem(CACHE_KEY, JSON.stringify(state));
  } catch (e) {
    console.error('writeCache failed', e);
  }
}

export function clearCache() {
  try {
    localStorage.removeItem(CACHE_KEY);
  } catch (e) {
    console.error('clearCache failed', e);
  }
}

// ── Pending-sync marker ──
// Separate from the cache blob and read/written synchronously, so it survives a tab
// getting killed/backgrounded mid-save (phone locked, iOS suspending the PWA, closing
// the tab right after typing) even across a full reload — see the fix in lib/sync.js's
// attachFirestoreSync(). Without this, a save that never confirmed to Firestore before
// the app restarted was silently discarded on the next boot, because the boot sequence
// trusted whatever Firestore said over the newer-but-unconfirmed local cache.
const PENDING_KEY = 'levelup_pending_v1';

export function readPendingSync() {
  try { return localStorage.getItem(PENDING_KEY) === '1'; }
  catch (e) { return false; }
}

export function setPendingSync(val) {
  try {
    if (val) localStorage.setItem(PENDING_KEY, '1');
    else localStorage.removeItem(PENDING_KEY);
  } catch (e) { console.error('setPendingSync failed', e); }
}
